import config from 'config';
import request from 'helpers/superagent';

export const logAsync = (data) => {
  const {access_token} = localStorage;
  request.post(`${config.elog.baseUrl}/usages`)
  .query({
    access_token,
  })
  .send(data)
  .endAsync()
}



/** WEBPACK FOOTER **
 ** ./src/app/helpers/elogAsync.js
 **/